import { TableColumnGroups } from "~/constants/tableColumnGroups"
import { POSpecificColumnGroups, PurchaseOrderTableColumn } from "./purchaseOrderTable"

export const BuyColumnGroups = { ...TableColumnGroups, ...POSpecificColumnGroups }
export type BuyColumnGroups = (typeof BuyColumnGroups)[keyof typeof BuyColumnGroups]

export enum BuySpecificColumn {
  // Hidden second-level row grouping (variant) used when grouping by a non-variant dimension.
  VariantGrouping = "variant-grouping",
  TotalQty = "totalQty",
  SuggestedOrderDelta = "suggestedOrderDelta",
  ETA = "expectedArrivalDate",
  ETD = "estimatedTimeOfDelivery",
  Covers = "coversPeriod",
  Vendor = "vendorId",
  DraftPurchaseOrder = "draftPurchaseOrderId",
  PurchaseOrderStatus = "purchaseOrderStatus",
  Notes = "notes",
}

export const BuyTableColumn = {
  ...PurchaseOrderTableColumn,
  ...BuySpecificColumn,
} as const
export type BuyTableColumn = (typeof BuyTableColumn)[keyof typeof BuyTableColumn]

const BUY_WAREHOUSE_QTY_PREFIX = "wh-qty-"

export function warehouseColumnId(warehouseId: string): string {
  return `${BUY_WAREHOUSE_QTY_PREFIX}${warehouseId}`
}

export function isWarehouseColumnId(colId: string): boolean {
  return colId.startsWith(BUY_WAREHOUSE_QTY_PREFIX)
}
